import { Texts, Media, Title } from "../Object";
import { Space } from "../Layout";
import { Scroll } from "../Animation";
const Point = () => {
  return (
    <>
      <div className="p-box__wrap--white">
        <Space size={['120px', '80px']}></Space>
        <div className="l-row">
          <div className="c-grid--center">
            <Title slug="point" enClass="c-text--center" jpClass="c-text--center"></Title>
          </div>
        </div>
        <Space size={["80px 0 0", "80px 0 0"]}>
          <List />
        </Space>
        <Space size={['120px', '80px']}></Space>
      </div>
    </>
  );
};

export const List = (props) => {
  const args = {
    slug: "point",
    length: 2,
    addText: [
      [
        "自社共同配送",
        "共同配送は、同じ着荷主のもとへ向かうトラックに各社の荷物を積み込むことで、配送コストを削減することができます。また、積載率が向上するため、少ない車両数で荷物を配送でき、配送効率の向上や人件費・燃料費の削減にもつながります。",
      ],
      [
        "全国で車両手配が可能",
        "当社は、チャーター便や軽貨物から大型車両までの車両手配を行い、<br>必要な時に必要な車両を手配することで、迅速な対応ができます。<br>全国に対応しており、一つの窓口で輸送の手配ができるため、お客様の業務の効率化やコスト削減に貢献します。",
        "当社ではJRコンテナを利用して、日本全国への荷物配送を行っております。弊社拠点の関西圏だけでなく、<br>全国に配送可能です。また、コンテナを使用することで既存の倉庫スペースを削減でき、物流コストの削減につながります。",
      ],
    ],
  };
  const Item = (props) => {
    return (
      <>
        <Scroll>
        <li className="items c-grid__items--point">
          <div className="c-grid__items--point__left">
            <Media class="p-img__number" src={`point/num${props.index}`} alt="number"></Media>
          </div>
          <div>
            <Texts
              class="c-text--main"
              slug={`point/title`}
              addText={args.addText[props.index][0]}
            ></Texts>
            <Space size={["48px 0 40px", "24px 0"]}>
              <Texts
                slug={`point/body`}
                addText={args.addText[props.index][1]}
              ></Texts>
            </Space>
            <Media src={`point/list${props.index}`} sp="sp" alt="list"></Media>
            {args.addText[props.index][2] && (
              <Space size={["40px 0 0", "24px 0 0"]}>
                <Texts
                  slug={`point/body`}
                  addText={args.addText[props.index][2]}
                ></Texts>
              </Space>
            )}
          </div>
        </li>
        </Scroll>
      </>
    );
  };
  let items = [];
  for (let i = 0; i < args.length; i++) {
    items.push(<Item key={i} index={i}></Item>);
  }

  return (
    <>
      <div className="l-row">
        <ul className="list c-grid__list--point">{items}</ul>
      </div>
    </>
  );
};

export default Point;
